module.exports = __webpack_public_path__ + "@/assets/img/mastercard-old.f459dd8d.svg";